import React from 'react'
import Helmet from 'react-helmet'
import favicon from 'default-track-favicon.png'
import TrackRouter from 'routers/Track'

export function themeImage(themeName='roadie', image) {
  return [process.env.REACT_APP_THEME_BUCKET, themeName, image].join('/')
}

const TrackApp = props => (
  <>
    <Helmet>
      <link rel="shortcut icon" href={favicon}></link>
    </Helmet>
    <TrackRouter {...props} />
  </>
)

export default TrackApp